module.exports = __webpack_public_path__ + "static/media/whitelogo.e3698930.png";